import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import axios from 'axios';
import GeolocationButton from './GeolocationButton';
import withError from '../shared/withError';
import { addMilliseconds, lastDayOfMonth } from 'date-fns';


class LocationInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            options: [],
            input: ''
        };
        // this.geocoder = new window.google.maps.Geocoder;
        // this.mapbox_geocoder = new window.MapboxGeocoder({
        //     accessToken: props.config.mapboxToken,
        //     proximity: {
        //         bbox: [
        //             props.config.swBounds.lng,
        //             props.config.swBounds.lat,
        //             props.config.neBounds.lng,
        //             props.config.neBounds.lat
        //         ]
        //     }
        // })
        this.onBlur = this.onBlur.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        // const bounds = new window.google.maps.LatLngBounds(
        //     new window.google.maps.LatLng(props.config.swBounds),
        //     new window.google.maps.LatLng(props.config.neBounds)
        // );
        // this.configOptions = {
        //     bounds,
        //     strictbounds: props.config.useStrict
        // };
    }

    // If we have initialized from a URL (GET) request
    // or permalink, geocode the displayValue
    componentDidMount() {
        if (this.props.value && (!this.props.displayValue)) {
            console.log(this.props.value);
            const coords = this.props.value.split(',').map(parseFloat);
            this.reverseGeocode({ lat: coords[0], lng: coords[1] }).then(res => {
                this.setState({input: res.data.features[0].place_name});
                this.returnValue(res.data.features[0]);
            }).catch(() => {
                this.returnValue(this.props.value, this.props.value);
            });
        }
    }

    // If the value has been updated elsewhere, geocode the display value
    // I'm not really sure this should be done here, it seems a little fishy
    // logic-wise, consider refactoring
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            if (this.props.displayValue === prevProps.displayValue) {
                const coords = this.props.value.split(',').map(parseFloat);
                console.log(coords);
                this.reverseGeocode({ lat: coords[0], lng: coords[1] }).then(res => {
                    this.returnValue(this.props.value, res.data.features[0].place_name);
                }).catch(() => {
                    this.returnValue(this.props.value, this.props.value);
                });
            }
        }
    }

    // Clear value stored in form
    clearValue(displayValue = '') {
        this.props.handleChange({
            target: {
                name: this.props.name,
                value: ''
            },
            params: {
                displayValue
            }
        });
    }

    returnError(err) {
        this.props.handleChange({
            target: {
                name: this.props.name,
                value: ''
            },
            error: err,
            params: {
                displayValue: ''
            }
        });
    }

    returnValue(value, displayValue = value.place_name) {
        let newValue;
        if (value.geometry) {
            const coords = value.geometry.coordinates;
            newValue = `${coords[1]},${coords[0]}`;
        } else {
            newValue = value;
        }
        
        let result = {
            target: {
                name: this.props.name,
                value: newValue
            },
            params: {
                displayValue,
            }
        };
        
        if (value.geometry) {
            result.params = {
                ...result.params,
                ...value
            };
        }
        
        this.props.handleChange(result);
        this.setState({input: displayValue});
    }

    reverseGeocode(coords) {
        return new Promise((resolve, reject) => {

            let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${coords.lng},${coords.lat}.json?access_token=${this.props.config.mapboxToken}`;
            const reverseGeocodeRequest = axios.create({
                baseURL: apiURL,
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json'
                }
            });
            reverseGeocodeRequest.get()
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    forwardGeocode(term, callback) {
        return new Promise((resolve, reject) => {

            const encodedSearch = encodeURIComponent(term);
            const mapboxKey = this.props.config.mapboxToken;
            let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedSearch}.json?access_token=${mapboxKey}`;

            if (this.props.config.swBounds && this.props.config.neBounds) {
                const { swBounds, neBounds } = this.props.config;
                apiURL += `&bbox=${swBounds.lng},${swBounds.lat},${neBounds.lng},${neBounds.lat}`;
            }
            const forwardGeocodeRequest = axios.create({
                baseURL: apiURL,
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json'
                }
            });

            forwardGeocodeRequest.get()
                .then(res => {
                    resolve(res.data.features);
                })
                .catch(err => {
                    reject(err);
                });

        })
    }

    handleInputChange(string, action) {
        if (action.action === "input-change") {
            this.setState({ input: string });
            if (string && string.length > 2) {
                this.forwardGeocode(string)
                    .then(res => {
                        this.setState({ options: res });
                    });
            }
        }
    }

    handleChange(value, event) {
        this.returnValue(value);
    }

    onGeolocate(res) {
        // If loading, disable this input until either result
        // or error is returned.
        if (res.loading) {
            this.setState({ disabled: true });
            this.clearValue('Loading...');
            return;
        }
        if (res.error) {
            this.setState({ disabled: false });
            this.returnError(res.error);
            return;
        }
        // Return coordinate value. Attempt to reverse geocode; if it fails, display coordstring
        const { lat, lng } = res.coords;
        const coordString = `${lng.toString().substr(0, 10)},${lat.toString().substr(0, 10)}`;
        this.returnValue(coordString);
        this.reverseGeocode(coordString)
            .then(res => {
                this.setState({ disabled: false });
                this.returnValue(coordString, res[0].formatted_address);
            })
            .catch(() => {
                this.setState({ disabled: false });
                this.returnValue(coordString, coordString);
            });
    }

    // If we have a value entered in the field, but no lat/lng for it yet
    // attempt to geocode the location name.
    onBlur() {
        if (!this.props.value && this.state.options && this.state.input) {
            this.returnValue(this.state.options[0]);
        }
    }

    getOptionValue = (option) => {
        if (option.geometry) {
            const coords = option.geometry.coordinates;
            const newOption = `${coords[1]},${coords[0]}`;
            return newOption;
        }
        //FIXME
        return '';
    }

    render() {
        const { name, fields, showSummary, title, placeholder, displayValue, geocode } = this.props;
        // console.log(fields);

        if (showSummary) {
            return (
                <div className="otp-location-summary">
                    {title}: {formatSummary(displayValue)}
                </div>
            );
        }

        console.log(this.state.input);

        return (
            <div className="otp-form-control otp-has-btn">
                <label htmlFor={name} className="screen-reader-text">{title}</label>
                <div className="autocomplete-form-control">
                    <Select
                        onInputChange={this.handleInputChange}
                        onChange={this.handleChange}
                        // loadOptions={this.forwardGeocode}
                        value={fields[name]}
                        inputValue={this.state.input}
                        placeholder={placeholder}
                        name={name}
                        id={name}
                        disabled={this.state.disabled}
                        onBlur={this.onBlur}
                        options={this.state.options}
                        getOptionLabel={option => option.displayValue || option.place_name}
                        getOptionValue={this.getOptionValue}
                    ></Select>
                </div>
                <GeolocationButton
                    handleClick={e => this.onGeolocate(e)}
                />
            </div>
        );
    }
}

// Some utilities

const formatSuggestion = (suggestion) => {
    if (suggestion.terms.length > 3) {
        const shortSuggestion = suggestion.terms.slice(0, -2).map(term => term.value);
        return shortSuggestion.join(', ');
    }
    return suggestion.description;
};

const formatSummary = displayValue => {
    const chopped = displayValue.split(',');
    if (chopped.length > 2) {
        return chopped.slice(0, 2).join(',');
    }
    return displayValue;
};


LocationInput.defaultProps = {
    placeholder: 'Enter Address or Intersection',
    disabled: false,
    displayValue: ''
};

const mapStateToProps = state => {
    return {
        config: state.config,
        geocode: state.geocode,
        fields: state.form.fields
    };
};

export default connect(mapStateToProps)(withError(LocationInput));
 